import { useMutation, useQueryClient } from '@tanstack/react-query';
import { suggestMenuItem, SuggestMenuItemRequest } from '@/api/endpoints/menu-items';
import { MENU_ITEMS_QUERY_KEYS } from '@/api/queries/menu-items';

/**
 * Hook for suggesting a new menu item
 *
 * Wraps the suggestMenuItem API call in a React Query mutation.
 * On success, invalidates menu item list and search queries
 * so that the new pending item appears across screens.
 */
export function useSuggestMenuItem(businessId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: SuggestMenuItemRequest) => suggestMenuItem(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: MENU_ITEMS_QUERY_KEYS.lists() });
      queryClient.invalidateQueries({ queryKey: MENU_ITEMS_QUERY_KEYS.searches() });
    },
  });
}
